module.exports = __webpack_public_path__ + "img/selected@2x.ceba074a.png";